import { useCreateOperator } from '../../../../contexts/CreateOperatorContext';
import { Divider } from '../../../../components/Divider';
import { SettingRow } from '../../../Manage/Operator/Settings/SettingRow';
import { SettingTag } from '../SettingTag';
import { Input } from '../../../../components/Input';
import React, { ChangeEvent } from 'react';

export const MediaFirstRequired = () => {
  const { operator, updateOperator } = useCreateOperator();

  if (operator.mediaFirstSettings === undefined) return null;

  return (
    <>
      <Divider />
      <SettingRow
        icon={<SettingTag name="MediaFirst" color="teal" size="sm" />}
        title="Tenant ID"
        level="sub"
      >
        <Input
          name="tenantId"
          className="w-[80px]"
          value={operator.mediaFirstSettings?.tenantId ?? ''}
          variant="contained"
          required
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                [event.target.name]: event.target.value,
              })
            )
          }
        />
      </SettingRow>
    </>
  );
};
